/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import { modalController } from '@ionic/vue';
import OtpModal from '../components/Otp.vue';

const openOtpModalHandle = ({ email }) => modalController
  .create({
    component: OtpModal,
    componentProps: { email },
    backdropDismiss: false,
    keyboardClose: false,
    cssClass: 'otpModal',
  })
  .then((modalElement) => {
    modalElement.present();
    modalElement.onDidDismiss();
  });

export { openOtpModalHandle };
